import { isObject } from "../../utils/objects";
import { getCrossID } from "../../utils/filters";
export const getSelectedFilters = (selected, entity) => {
  var _Object$keys, _Object$keys2;
  if (!selected || Object.keys(selected).length === 0) return [];

  // When there is relatedEntities selector needs to be treated as an object.
  let isArray = Array.isArray(selected === null || selected === void 0 ? void 0 : selected[(_Object$keys = Object.keys(selected)) === null || _Object$keys === void 0 ? void 0 : _Object$keys[0]]);
  let newSelected = [];
  if (isArray) {
    newSelected = Object.keys(selected).reduce((arr, key) => {
      var _selected$key$options;
      const isArray = Array.isArray(selected[key].options);
      if (isArray && ((_selected$key$options = selected[key].options) === null || _selected$key$options === void 0 ? void 0 : _selected$key$options.length) > 0) {
        arr = [...arr, ...selected[key].options];
      }
      return arr;
    }, []);
  } else if (selected !== null && selected !== void 0 && selected[(_Object$keys2 = Object.keys(selected)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2[0]]) {
    newSelected = Object.keys(selected).reduce((arr, key) => {
      if (selected[key].options && Array.isArray(selected[key].options)) {
        arr = [...arr, ...selected[key].options];
      } else if (selected[key].options && isObject(selected[key].options)) {
        Object.keys(selected[key].options).forEach(key2 => {
          selected[key].options[key2].options.forEach(filterId => {
            if (entity && key === (entity === null || entity === void 0 ? void 0 : entity.entity)) arr.push(filterId);else arr.push(getCrossID(filterId, key));
          });
        });
      }
      return arr;
    }, []);
  }
  return newSelected;
};